import React from 'react';
import {
  Stack, TextField, Button, Chip, Typography, Box,
  List, ListItem, ListItemIcon, ListItemText, IconButton, Link,
} from '@mui/material';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SectionCard from '../ui/SectionCard';
import { formatDateTime } from '../../utils/format';

// เอกสารแนบของโครงการ — ใช้ร่วมกับทั้งเอกสารประมูล (TOR/BOQ) และเอกสารตอน "จบงาน"
// (ใบสั่งซื้อ/ใบส่งมอบงาน ฯลฯ) ชื่อเอกสารตั้งเองได้อิสระ ไม่ผูกชุดค่าคงที่แล้ว
export function TenderDocumentsPanel({
  documents, docType, onDocTypeChange, docFiles, onFilesChange, uploading, onUpload, onDelete,
}) {
  const docs = documents || [];

  return (
    <SectionCard icon={<AttachFileOutlinedIcon />} title="เอกสารแนบ" accentColor="info.main">
      <Stack
        direction="row" spacing={1.5} alignItems="flex-start" flexWrap="wrap" useFlexGap
        sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: 'action.hover' }}
      >
        <TextField
          size="small" label="ชื่อเอกสาร" placeholder="เช่น TOR, BOQ, ใบสั่งซื้อ"
          value={docType} onChange={(e) => onDocTypeChange(e.target.value)}
          sx={{ minWidth: 200, bgcolor: 'background.paper' }}
        />
        <Button component="label" variant="outlined" sx={{ borderRadius: 2, bgcolor: 'background.paper' }}>
          เลือกไฟล์
          <input type="file" multiple hidden onChange={(e) => onFilesChange(Array.from(e.target.files || []))} />
        </Button>
        <Button
          variant="contained" startIcon={<UploadFileIcon />} disabled={docFiles.length === 0 || !docType.trim() || uploading}
          onClick={onUpload} sx={{ borderRadius: 2 }}
        >
          {uploading ? 'กำลังอัปโหลด...' : 'อัปโหลด'}
        </Button>
        {docFiles.length > 0 && (
          <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ width: '100%' }}>
            {docFiles.map((f, idx) => (
              <Chip
                key={`${f.name}-${idx}`} size="small" label={f.name}
                onDelete={() => onFilesChange(docFiles.filter((_, i) => i !== idx))}
              />
            ))}
          </Stack>
        )}
      </Stack>

      {docs.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
          ยังไม่มีเอกสารแนบ
        </Typography>
      ) : (
        <List dense disablePadding>
          {docs.map((doc) => (
            <ListItem
              key={doc.id}
              disableGutters
              secondaryAction={(
                <IconButton size="small" color="error" onClick={() => onDelete(doc.id)}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              )}
              sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider', '&:last-of-type': { borderBottom: 0 } }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <InsertDriveFileOutlinedIcon color="action" />
              </ListItemIcon>
              <ListItemText
                primary={(
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip size="small" label={doc.doc_type} variant="outlined" />
                    <Link href={doc.file_url} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontSize: '0.875rem' }}>
                      {doc.file_name || doc.file_url}
                    </Link>
                  </Box>
                )}
                secondary={formatDateTime(doc.uploaded_at)}
              />
            </ListItem>
          ))}
        </List>
      )}
    </SectionCard>
  );
}

export default TenderDocumentsPanel;
